/* eslint-disable no-unused-vars */
import {
  useElement,
  useState,
  useStaleLayout,
  useRect,
  useEffect,
  useModel,
} from '@nebula.js/stardust';
import picassojs from 'picasso.js';
import picassoQ from 'picasso-plugin-q';
import picassoHammer from 'picasso-plugin-hammer';
import * as d3 from 'd3';

export default function supernova() {
  const picasso = picassojs({
    palettes: [{
      key: 'sequential',
      colors: [
        ['#dd8ca4', '#8a1538'],
      ],
    }],
  });
  picasso.use(picassoQ);
  picasso.use(picassoHammer);

  return {
    qae: {
      properties: {
        qHyperCubeDef: {
          qDimensions: [],
          qMeasures: [],
          qInitialDataFetch: [{ qWidth: 2, qHeight: 5000 }],
          qSuppressZero: false,
          qSuppressMissing: true,
        },
        showTitles: true,
        title: '',
        subtitle: '',
        footnote: '',
      },
      data: {
        targets: [
          {
            path: '/qHyperCubeDef',
            dimensions: {
              min: 1,
              max: 1,
            },
            measures: {
              min: 1,
              max: 1,
            },
          },
        ],
      },
    },
    component() {
      const element = useElement();
      const layout = useStaleLayout();
      const rect = useRect();
      const model = useModel();

      const [instance, setInstance] = useState();

      useEffect(() => {
        const p = picasso.chart({
          element,
          data: [],
          settings: {},
        });

        setInstance(p);

        return () => {
          p.destroy();
        };
      }, []);

      useEffect(() => {
        if (!instance) {
          return;
        }

        instance.update({
          data: [
            {
              type: 'q',
              key: 'qHyperCube',
              data: layout.qHyperCube,
            },
          ],
          settings: {
            scales: {
              x: {
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                  },
                },
                padding: 0.2,
              },
              y: {
                data: {
                  field: 'qMeasureInfo/0',
                },
                invert: true,
                include: [0],
              },
              color: {
                data: {
                  field: 'qMeasureInfo/0',
                },
                type: 'color',
              },
            },
            components: [
              {
                type: 'axis',
                dock: 'left',
                scale: 'y',
              },
              {
                type: 'axis',
                dock: 'bottom',
                scale: 'x',
              },
              {
                key: 'bars',
                type: 'box',
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                    props: {
                      start: 0,
                      end: { field: 'qMeasureInfo/0' },
                    },
                  },
                },
                settings: {
                  major: { scale: 'x' },
                  minor: { scale: 'y' },
                  box: {
                    fill: {
                      scale: 'color',
                      ref: 'end',
                    },
                  },
                },
              },
              {
                type: 'labels',
                displayOrder: 2,
                settings: {
                  sources: [{
                    component: 'bars',
                    selector: 'rect',
                    strategy: {
                      type: 'bar',
                      settings: {
                        direction: 'up',
                        labels: [{
                          label({ data }) {
                            return data ? data.end.label : '';
                          },
                          placements: [
                            { position: 'inside', justify: 1, fill: '#fff' },
                            { position: 'outside', justify: 0, fill: '#666' },
                          ],
                        }],
                        fontSize: 10,
                      },
                    },
                  }],
                },
              },
            ],
            interactions: [],
          },
        });
      }, [layout, instance]);

      useEffect(() => {
        if (!instance) {
          return;
        }
        instance.update();
      }, [rect.width, rect.height, instance]);
    },
  };
}
